export const formatNumberCompact = (
  value,
  showDecimal = false,
  decimalPlaces = 1
) => {
  if (value === null || value === undefined) return "0";

  // Convert to number if it's a string
  const numValue = typeof value === "string" ? parseFloat(value) : value;

  // Handle zero or invalid values
  if (!numValue || isNaN(numValue)) return "0";

  const absValue = Math.abs(numValue);

  // Format based on value range
  if (absValue >= 1_000_000_000) {
    const formatted = showDecimal
      ? (numValue / 1_000_000_000).toFixed(decimalPlaces)
      : Math.floor(numValue / 1_000_000_000);
    return `${formatted}B`;
  } else if (absValue >= 1_000_000) {
    const formatted = showDecimal
      ? (numValue / 1_000_000).toFixed(decimalPlaces)
      : Math.floor(numValue / 1_000_000);
    return `${formatted}M`;
  } else if (absValue >= 1_000) {
    const formatted = showDecimal
      ? (numValue / 1_000).toFixed(decimalPlaces)
      : Math.floor(numValue / 1_000);
    return `${formatted}K`;
  }

  return numValue.toString();
};
